<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {
            value: [String, Number, Array],
            label: String,
            labelWidth: String,
            field: String,
            disabled: {
                type: Boolean,
                default: false,
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            filterable: {
                type: Boolean,
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: ''
            }
        },
        methods: {
            ...mapActions('dictionaries/webReport', {
                get_items: 'get_items',
            }),
            change_value(v) {
                console.info("web-report(): new value: ", v);
                this.$emit('input', v);
               this.$emit('change', v);
               if (this.field) {
                    this.$emit('change-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_value(v) {
                console.info("input_value: ", v);
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
        },
        computed: {
            ...mapState('dictionaries/webReport', {
                list: 'items'
            }),

            append() {
                return this.show_remove;
            },
            show_remove() {
                if (this.disabled) return false;
                if (!this.multiple) return false;
                if (this.value && !this.value.length) {
                    return false;
                }
                return true;
            },
        },
        watch: {},
        mounted() {
            this.get_items();
        },

        components: {},
    }
</script>
<template>
    <form-group class="dictionary dictionary-web-report" :label-width="labelWidth" :append="append" :label="label">
        <el-select
                :value="value"
                @change="change_value"
                @input="input_value"
                :disabled="disabled"
                :filterable="filterable"
                :multiple="multiple"
                :collapse-tags="multiple"
                placeholder="Выберите"
                :clearable="clearable">
            <el-option v-for="item in list"
                       :value="item.Id"
                       :label="item.Name"
                       :key="item.Id">
            </el-option>
        </el-select>
    </form-group>
</template>
